import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  attendanceGetAccess,
  attendanceLoadMyLeaveBalances,
  attendanceLoadMyPrehled,
  type AttendanceLeaveBalance,
  type AttendanceLeaveKind,
} from '../../lib/apiPhpAdapter'
import './CabinetLeaveBalances.css'

/** Kompaktní zůstatky DOV / SAM / banka — bez denní tabulky (ta je v Docházce). */
export function CabinetLeaveBalances() {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)
  const [balances, setBalances] = useState<Record<AttendanceLeaveKind, AttendanceLeaveBalance> | null>(
    null,
  )
  const [bankaLabel, setBankaLabel] = useState<string | null>(null)
  const [bankaPosted, setBankaPosted] = useState(false)

  const reload = useCallback(async () => {
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth() + 1
    try {
      const [b, p] = await Promise.all([
        attendanceLoadMyLeaveBalances(year),
        attendanceLoadMyPrehled(year, month),
      ])
      setBalances(b.balances)
      setBankaLabel(p.banka?.closing_label ?? null)
      setBankaPosted(Boolean(p.banka?.posted))
    } catch {
      setBalances(null)
      setBankaLabel(null)
    }
  }, [])

  useEffect(() => {
    let cancelled = false
    attendanceGetAccess()
      .then((a) => {
        if (!cancelled) setVisible(Boolean(a.canUser))
      })
      .catch(() => {
        if (!cancelled) setVisible(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    if (!visible) return
    void reload()
  }, [visible, reload])

  if (!visible || !balances) return null

  return (
    <div className="cab-leave" aria-label="Zůstatky dovolené a banky hodin">
      <div className="cab-leave__item">
        <span>Dovolená</span>
        <strong>
          {balances.dovolena.remaining} / {balances.dovolena.entitled} h
        </strong>
      </div>
      <div className="cab-leave__item">
        <span>Samostudium</span>
        <strong>
          {balances.samostudium.remaining} / {balances.samostudium.entitled} d
        </strong>
      </div>
      {bankaLabel ? (
        <div className="cab-leave__item">
          <span>Banka hodin</span>
          <strong>{bankaLabel}</strong>
          <em>{bankaPosted ? 'po uzávěrce' : 'odhad'}</em>
        </div>
      ) : null}
      <button type="button" className="cab-leave__link" onClick={() => navigate('/attendance/user')}>
        Docházka →
      </button>
    </div>
  )
}
